import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

import { PORTFOLIOS_FRAGMENT } from './portfolios-fragment';

export const queryFn = async () => {
  const response = await gqlClient.request(
    gql(
      `
      query getPortfolios {
        Portfolios {
          ...portfolioFields
        }
      }
      
    `,
      [PORTFOLIOS_FRAGMENT]
    ),
    {}
  );

  if ('Portfolios' in response) {
    return response.Portfolios;
  }

  return [];
};
